import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import { useDialog } from "_shared/_providers/dialogs/dialog";
import Loader from "_shared/_views/loading/loader";
import { MouseEvent } from "react";
import Session from "users/__session/session";
import { Masked } from "work/_shared/masked-fields";
import Proposal from "work/proposals/proposal";
import ViewVendorTeam from "work/work-agreements/teams/vendor-team/_views/vendor-team-view";

const StyledLink = styled(Link)(
  ({ theme }) => ({
    alignItems: "center",
    color: theme.palette.text.primary,
    cursor: "pointer",
    display: "flex",
    overflow: "hidden",
    textDecoration: "underline",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
);

type VendorTeamLinkProps = {
  proposal: Proposal;
  session: Session;
};

export default function VendorTeamLink(props: Readonly<VendorTeamLinkProps>) {
  const { proposal } = props;

  const { openDialog, closeDialog } = useDialog();

  function handleClick(event: MouseEvent) {
    event.stopPropagation();

    if (!proposal?.vendorTeam || Masked.isMasked(proposal.vendorTeam)) return;

    openDialog({
      title: "Team Members",
      component: <Loader />,
    });

    if (!proposal || Masked.isMasked(proposal.vendorTeam)) return;

    closeDialog();

    openDialog({
      title: `${proposal.name} Team`,
      MuiProps: { maxWidth: "md" },
      component: <ViewVendorTeam leader={proposal.vendorTeam?.leader} members={proposal.vendorTeam?.members} />,
    });
  }

  return (
    <StyledLink onClick={handleClick}>
      View
    </StyledLink>
  );
}
